// Libraries
import { HeaderLayout } from '../../layouts';
import { Card, Alert, FormElems, LoginFlowComps } from '../../components';
import {
    forgotPasswordRequest,
    forgotPasswordError,
} from '../../redux/common/auth/auth.actions';
import { getLoginRedirectPath } from '../../utils/helperMethods';
import forgotImg from '../../static/images/forgotimg.png';
import validate from './validator';
import React, { useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';

// Layouts

// Components

// Actions

// Helper Methods

// Images

// Validator

// Styles
import './forgotPassword.scss';

const ForgotPassword = props => {
    const { handleSubmit, actions, auth } = props;

    const history = useHistory();

    const getRedirectPath = useMemo(
        () =>
            getLoginRedirectPath(
                auth.resourceDetails.resources,
                auth.resourceDetails.permissions
            ),
        [auth.resourceDetails.resources, auth.resourceDetails.permissions]
    );

    // const redirectPath =
    //     location.state && location.state.from
    //         ? location.state.from.pathname
    //         : getRedirectPath;

    const redirectPath = getRedirectPath;

    useEffect(() => {
        if (auth.isLoggedIn) {
            history.push(redirectPath);
        }
    }, [history, auth.isLoggedIn, redirectPath]);

    // Reset forgot password error
    const resetForgotError = useCallback(() => {
        if (auth.forgotPasswordError) {
            actions.forgotPasswordError({
                forgotPasswordError: '',
            });
        }
    }, [actions, auth.forgotPasswordError]);

    useEffect(() => {
        return () => {
            // Reset forgot password error
            resetForgotError();
        };
    }, [resetForgotError]);

    /**
     * Called on login form submit
     *
     * @param {Object} values - Object of all form field values
     * @returns {undefined}
     */
    function handleForgotSubmit(values) {
        actions.forgotPasswordRequest(values);
    }

    return (
        <HeaderLayout>
            {!auth.isLoggedIn && (
                <div className="forgot-pass-wrapper">
                    <Card customClass="forgot-card">
                        <LoginFlowComps.ImageSplitView splitImg={forgotImg}>
                            <div className="forgot-pass-form-wrapper">
                                <div className="form-head">FORGOT PASSWORD</div>
                                <div className="form-subhead">
                                    Enter your registered email Id to receive
                                    password reset link
                                </div>
                                <form
                                    className="forgot-pass-form"
                                    onSubmit={handleSubmit(handleForgotSubmit)}
                                    onChange={resetForgotError}
                                >
                                    <div className="form-field">
                                        <p className="label">Email ID</p>
                                        <Field
                                            name="email"
                                            type="text"
                                            component={FormElems.Input}
                                            placeholder="Enter Email ID"
                                        />
                                    </div>

                                    {auth.forgotPasswordError && (
                                        <Alert>
                                            {auth.forgotPasswordError}
                                        </Alert>
                                    )}

                                    <div className="form-btn">
                                        <FormElems.Button
                                            buttonType="primary"
                                            text="SEND LINK"
                                        />
                                        <Link to="/login">Back to Login</Link>
                                    </div>
                                </form>
                            </div>
                        </LoginFlowComps.ImageSplitView>
                    </Card>
                </div>
            )}
        </HeaderLayout>
    );
};

ForgotPassword.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    handleSubmit: PropTypes.func,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            forgotPasswordRequest,
            forgotPasswordError,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'forgot-password',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ForgotPassword);
